var i = (a, o, r) => new Promise((p, s) => {
  var c = (t) => {
    try {
      e(r.next(t));
    } catch (n) {
      s(n);
    }
  }, m = (t) => {
    try {
      e(r.throw(t));
    } catch (n) {
      s(n);
    }
  }, e = (t) => t.done ? p(t.value) : Promise.resolve(t.value).then(c, m);
  e((r = r.apply(a, o)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function l(a) {
  return i(this, null, function* () {
    const {
      data: o
    } = yield f.post(
      "/crmapi/internal/customer/page",
      a
    );
    return o == null ? void 0 : o.data;
  });
}
export {
  l as postPage
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/apigateway.oppein.com/crmapi/internal/customer/page/post.js
// module id = 1748
// module chunks = 41